












































































import { Vue, Component, Prop } from "vue-property-decorator";
import TotalPopulationData from "@/components/Detail/TotalData.vue";
import { currentScoutingStore } from "@/store/typed";
import PopulationsTab from "@/components/Detail/PopulationsTab.vue";
import MediaTab from "@/components/Detail/MediaTab.vue";
import VContentLoading from "@/components/VContentLoading.vue";

@Component({
  components: {
    TotalPopulationData,
    PopulationsTab,
    MediaTab,
    VContentLoading,
  },
})
export default class ScoutingDetails extends Vue {
  private isOpen = true;
  private selected = "population";
  private population = 0;

  open() {
    this.isOpen = true;
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  get isIsocronLoading() {
    return !currentScoutingStore.scoutingPlaces.every(
      (e) => e.isocron?.status === "completed"
    );
  }

  get isMedia() {
    return this.selected === "media";
  }

  get isPopulation() {
    return this.selected === "population";
  }

  get isocronIds() {
    return currentScoutingStore.scoutingPlaces.map((o) => o.isocron.id);
  }

  get areaIds() {
    return currentScoutingStore.scoutingAreas.map((o) => o.id);
  }

  onPopulationChanged(value: number) {
    this.population = value;
  }
}
